// import PremiumPopup from "../Components/premiumPopop";

// In your application's entrypoint
const { __ } = wp.i18n;
const { InnerBlocks, useBlockProps } = wp.blockEditor;
const { useSelect, dispatch } = wp.data;
const { Button, Placeholder, Modal } = wp.components;
const { useEffect } = wp.element;
const { registerBlockType } = wp.blocks;
import { useState } from "react";
// import { Tooltip } from "@wordpress/components";

registerBlockType("html5-player/parent", {
  title: __("HTML5 Video Player Form", "h5vp"),
  icon: "format-video",
  category: "media",
  keywords: [__("HTML5 Video Player", "h5vp"), __("Media Player", "h5vp")],
  supports: {
    inserter: false,
    reusable: false,
    html: false,
  },

  edit: (props) => {
    const blockProps = useBlockProps();
    const { clientId, isSelected } = props;
    const innerBlocks = useSelect((select) => select("core/block-editor").getBlock(clientId).innerBlocks);
    const [isPremium, setIsPremium] = useState(h5vpBlock?.isPipe);

    useEffect(() => {
      if (isSelected) {
        wp.data.dispatch("core/edit-post").openGeneralSidebar("edit-post/block");
      }
    }, [isSelected]);

    // make sure we don't check template validity because is's buggy as fuck
    dispatch("core/block-editor").setTemplateValidity(true);

    // don't add reusable videos to a reusable video

    const insertBlockType = (type) => {
      const block = wp.blocks.createBlock(`html5-player/${type}`);
      return dispatch("core/block-editor").insertBlock(block, 0, clientId);
    };

    const appenderToUse = () => {
      if (innerBlocks.length === 0) {
        return <InnerBlocks.ButtonBlockAppender />;
      } else {
        return false;
      }
    };

    if (!innerBlocks?.length) {
      return (
        <div>
          {/* {!h5vpBlock?.isPipe && <PremiumPopup />} */}
          <div {...blockProps}>
            <Placeholder
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="html5-block-icon"
                >
                  <polygon points="23 7 16 12 23 17 23 7"></polygon>
                  <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
                </svg>
              }
              instructions={__("Choose a video type to get started.", "h5vp")}
              label={__("Choose a Video Type", "h5vp")}
            >
              <Button
                isPrimary
                onClick={() => {
                  insertBlockType("video");
                }}
              >
                {__("Video", "h5vp")}
              </Button>
              <Button
                disabled={!isPremium}
                isPrimary
                onClick={() => {
                  insertBlockType("youtube");
                }}
              >
                {__("Youtube", "h5vp")}
              </Button>
              <Button
                disabled={!isPremium}
                isPrimary
                onClick={() => {
                  insertBlockType("vimeo");
                }}
              >
                {__("Vimeo", "h5vp")}
              </Button>
              {!isPremium && <p style={{ marginTop: "8px", fontSize: "15px", color: "#d52525" }}>{__("Youtube and Vimeo is available on pro version!", "h5vp")}</p>}
            </Placeholder>
            <InnerBlocks templateLock={false} allowedBlocks={["html5-player/video", "html5-player/vimeo", "html5-player/youtube"]} renderAppender={() => false} />
          </div>
        </div>
      );
    }

    return (
      <div>
        <div {...blockProps}>
          <InnerBlocks templateLock={false} allowedBlocks={["html5-player/video", "html5-player/vimeo", "html5-player/youtube"]} renderAppender={() => appenderToUse()} />
        </div>
      </div>
    );
  },

  save: () => {
    const blockProps = useBlockProps.save();
    return (
      <div {...blockProps}>
        <InnerBlocks.Content />
      </div>
    );
  },
});
